<template>
    <!-- 错题库页面 -->
    <section class="container">
        <Header></Header>
        <div class="wrapper TestM">
            <div class="locationM text-left">
                <Breadcrumb>
                    <img class="img" src="../assets/location.png" alt="">
                    当前位置：
                    <BreadcrumbItem to="/">首页</BreadcrumbItem>
                    <BreadcrumbItem>测试</BreadcrumbItem>
                    <BreadcrumbItem>错题库</BreadcrumbItem>
                </Breadcrumb>
            </div>
            <div class="innerM">
                <div class="title">
                    错题库
                </div>
                <div class="inner-wrapper text-left">
                    <div class="item" v-for="(data, index) in dataList" :key="index">
                        <div class="subject" >
                            <div class="question">
                                [{{data.questionTypeName}}] {{data.questionTitle}}（{{data.score}}分）
                            </div>
                            <!--单选题-->
                            <RadioGroup v-model="answertag"  v-if="data.questionType == 1" >
                              <div class="options" v-for="(option, index2) in data.optionList" :key="index2">
                                <Radio :label="option.tag" disabled>
                                  <span>{{option.title}}</span>
                                </Radio>
                              </div>
                            </RadioGroup>
                            <!--多选题-->
                            <CheckboxGroup v-model="answertags" v-if="data.questionType == 2">
                              <div class="options" v-for="(option, index2) in data.optionList" :key="index2">
                                <Checkbox :label="option.tag" disabled>
                                  <span>{{option.title}}</span>
                                </Checkbox>
                              </div>
                            </CheckboxGroup>
                            <!--单判断题-->
                            <RadioGroup v-model="answertag" v-if="data.questionType == 3" >
                              <div class="options" v-for="(option, index2) in data.optionList">
                                <Radio :label="option.tag" disabled>
                                  <span>{{option.title}}</span>
                                </Radio>
                              </div>
                            </RadioGroup>
                            <div class="answer">
                                正确答案：{{data.rightAnswer}}
                              <!--<span class="choice">你的选择：{{data.userAnwer}} {{data.userAnwers}}</span>-->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Footer></Footer>
    </section>
</template>

<script>
    import Header from './components/Header'
    import Footer from './components/Footer'
    export default {
        name: "ProblemLibrary",
        data(){
            return {
              dataList:[],
              answertag:1,  //单选题正确答案
              answertags:[1] //多选题正确答案
            }
        },
        mounted(){
            this.onload();
          this.setTab();

        },
        methods: {
            onload(){
              //初始化
              var that = this;
              var token =  that.$cookie.get('xjaf-token');
              var username =  that.$cookie.get('xjaf-user');
              if(token != null && username != null){
                this.getInstance();
                //恢复滚动
                $('body').removeAttr('style');
              }else{
                this.$store.commit('login');
              }
            },
            getInstance(){
                var that = this;
                var modelData = {};
                this.$http({
                    url: that.webhost + 'exercise/mistakeQuestionList/' + that.$route.params.exerciseId,
                    method: 'POST',
                    data: modelData
                }).then(({data}) => {
                    if (data && data.code === 0) {
                        var tmp = data.data;
                        for (var i = 0 ; i < tmp.length ; i++) {
                          switch (tmp[i].questionType) {
                            case 1:
                              tmp[i].questionTypeName = '单选题';
                              break;
                            case 2:
                              tmp[i].questionTypeName = '多选题';
                              break;
                            case 3:
                              tmp[i].questionTypeName = '判断题';
                              break;
                          }
                          that.dataList = tmp;
                        }
                    } else {
                        that.$Message.error(data.msg)
                    }
                })
            },
        },
        components: {
            Header,
            Footer
        }
    }
</script>

<style scoped>
    .wrapper{
        width: 1200px;
        min-width: 1200px;
        margin: 0 auto;
        margin-top: 20px;
        margin-bottom: 90px;
        font-family: "PingFang SC";
    }
    .title{
        text-align: left;
        font-size: 25px;
        line-height: 72px;
        color: #000;
        border-bottom: solid 2px #ccc;
    }
    .locationM{
        height: 50px;
        line-height: 50px;
    }
    .locationM .ivu-breadcrumb{
        font-size: 15px;
        color: #000;
    }
    .locationM img{
        width: 23px;
        height: 22px;
        margin-right: 5px;
        position: relative;
        top: 3px;
    }
    .inner-wrapper{
        padding: 20px;
    }
    .subject{
        padding: 15px 0;
    }
    .question{
        color: #333;
        font-size: 17px;
        line-height: 35px;
    }
    .options span{
        font-size: 16px;
        line-height: 30px;
        position: relative;
        top: 2px;
        padding-left: 10px;
    }
    .answer{
        font-size: 16px;
        line-height: 30px;
        margin-top: 10px;
    }
    .choice{
        color: red;
        margin-left: 40px;
    }
</style>

<style>
    .TestM .ivu-radio-disabled.ivu-radio-checked .ivu-radio-inner {
        border-color: red;
        background-color: #fff;
    }
    .TestM .ivu-radio-disabled.ivu-radio-checked  .ivu-radio-inner:after {
        background-color: red;
        border-color: red;
    }
    .TestM .ivu-checkbox-disabled.ivu-checkbox-checked .ivu-checkbox-inner {
        background-color: #fff;
        border-color: red;
    }
    .TestM .ivu-checkbox-disabled.ivu-checkbox-checked .ivu-checkbox-inner:after{
        border-color: red;
    }
    .TestM .ivu-checkbox-disabled+span{
        color: inherit;
    }
</style>



// WEBPACK FOOTER //
// src/views/ProblemLibrary.vue